<template>
	<div>
		<a-spin :tip="spinnerLoaderLabel" size="large" :spinning="spinnerLoader">
			<div class="card">
				<div class="card-body">
					<div class="row">
						<div class="col-md-6 pt10">
							<h5>
								<strong>Catálogo de motivos de ingreso y egreso de dinero</strong>
							</h5>
						</div>
						<div class="col-md-6 text-right">
							<a-button class="btn btn-info" icon="plus" @click="onAddRecord()">Añadir</a-button>
							<a-button class="btn btn-success ml5" icon="reload" @click="onReload()" />
						</div>
						<div class="col-md-12">
							<hr class="hrText m0" data-content="♦" />
						</div>
					</div>
					<div class="row">
						<div class="col-md-12 pt10">
							<a-table :columns="columns" :dataSource="bankingInstitutionsList" rowKey="id">
								<span slot="active" slot-scope="record">
									<a-tag color="green" v-if="record.active">Activo</a-tag>
									<a-tag color="red" v-else>Inactivo</a-tag>
								</span>
								<span slot="action" slot-scope="record">
									<a-button type="info" size="small" icon="edit" @click="onEditRecord(record)" />
									<a-button class="ml5" size="small" :icon="record.active ? 'minus-circle' : 'plus-circle'" @click="onToggleRecord(record.id, record.active)" />
								</span>
							</a-table>
						</div>
					</div>
				</div>
			</div>
		</a-spin>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'
import _ from 'lodash'

export default {
	name: 'cashflowCatalogView',
	data() {
		return {
			columns: [
				{
					title: 'ID',
					dataIndex: 'id',
					align: 'center',
				},
				{
					title: 'Descripción',
					dataIndex: 'short_name',
					align: 'center',
				},
				{
					title: 'Estatus',
					scopedSlots: { customRender: 'active' },
					align: 'center',
				},
			],
			modal: {
				visible: false,
				title: '',
				payload: {},
			},
		}
	},
	computed: {
		...mapGetters('user', ['user']),
		...mapGetters('bankingInstitutions', ['bankingInstitutionsList']),
		spinnerLoaderLabel() {
			return this.$store.state.bankingInstitutions.spinnerLoaderLabel
		},
		spinnerLoader() {
			return this.$store.state.bankingInstitutions.spinnerLoader
		},
		isUserAdmin() {
			return this.user.is_admin ? true : false
		},
	},
	beforeMount() {
		if (this.isUserAdmin) {
			this.columns.push({
				title: 'Acciones',
				scopedSlots: { customRender: 'action' },
				align: 'right',
			})
		}
	},
	mounted() {
		if (this.bankingInstitutionsList.length == 0) {
			this.initModule()
		}
	},
	methods: {
		initModule() {
			this.$store.dispatch('bankingInstitutions/GET')
		},
		onReload() {
			this.initModule()
		},
		onAddRecord() {
			this.modal = {
				visible: true,
				title: 'Añadir registro de Institución Bancaria',
				payload: {},
			}
		},
		onEditRecord(record) {
			this.modal = {
				visible: true,
				title: 'Editar registro de Institución Bancaria',
				payload: _.cloneDeep(record),
			}
		},
		onToggleRecord(id, status) {
			Swal.fire({
				title: 'Atención',
				text: `¿Desea ${status ? 'deshabilitar' : 'habilitar'} el registro?`,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Sí, continuar',
				cancelButtonText: 'Cancelar',
			}).then((result) => {
				if (result.isConfirmed) {
					if (status) {
						this.$store.dispatch('bankingInstitutions/DISABLE', id)
					} else {
						this.$store.dispatch('bankingInstitutions/ENABLE', id)
					}
				}
			})
		},
		onCloseModal() {
			this.modal.visible = false
		},
	},
}
</script>